// App version and copyright information
const APP_VERSION = '2.3.4';
const COPYRIGHT_TEXT = `© 2025 MyCarParkedWhere.com | developed by KaiJian | v${APP_VERSION}`;

export {
  APP_VERSION,
  COPYRIGHT_TEXT
}; 